module.exports = __webpack_public_path__ + "static/img/2.eaf6cba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store_files/images/colorpop/2.jpg
// module id = s5SC
// module chunks = 1